module.exports = __webpack_public_path__ + "front/img/kv.951098fc.png";